import { DatabaseIdGenerator } from 'in-time-core';

export function createServerDatabaseIdGenerator(): DatabaseIdGenerator {
  return new DatabaseIdGenerator((array) => globalThis.crypto.getRandomValues(array));
}
